export const SERVICE_TYPES = [
  "Pintura",
  "Estrutural",
  "Encanador",
  "Eletricista",
  "Vidraçaria",
  "Pragas",
  "Aquecedores",
  "Ar-condicionado",
  "Infiltração",
  "Jardinagem",
  "Faxina",
  "Marcenaria",
  "Assistência técnica",
  "Redes de proteção",
  "Central de segurança",
  "Desentupimento",
  "Impermeabilização",
  "Telhado / Calhas",
  "Pisos e Revestimentos",
  "Gesso / Drywall",
  "Portões automáticos",
  "Persianas e Cortinas",
  "Limpeza de caixa d'água",
  "Piscina",
  "Chaveiro",
  "Energia solar",
  "Outros",
];

export const PRIORITIES = ["Urgente", "Média", "Baixa"];

export const slugify = (s) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-");
